<template>
  <c-row>
    <c-col col="6">
      <c-card>
        <c-card-header>
          <strong>Komponen Gaji</strong>
        </c-card-header>
        <c-card-body>
          <c-form>
            <div class="form-group form-row">
              <label for="name" class="col-form-label col-sm-3">Nama</label>
              <div class="col-md-9">
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="{ 'has-error': hasError.name }"
                  v-model="si.name"
                  placeholder="Nama Komponen"
                  id="name"
                />
              </div>
            </div>
            <div class="form-group form-row">
              <label for="name" class="col-form-label col-sm-3">Tipe</label>
              <div class="col-md-9">
                <select class="form-control" v-model="si.type">
                  <option value="">--- pilih tipe komponen ---</option>
                  <option value="+">Tunjangan</option>
                  <option value="-">Potongan</option>
                </select>
              </div>
            </div>
          </c-form>
        </c-card-body>
        <c-card-footer>
          <sur-button
            :object="si"
            @onSave="save"
            @onUpdate="update"
            @onReset="reset"
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
import { HTTPAUTH } from "../../lib/httplib";
import SURButton from "../../components/SURButton";

export default {
  name: "Add",
  components: {
    'sur-button': SURButton,
  },
  data () {
    return {
      si: {},
      hasError: {}
    }
  },
  created () {
    const query = this.$route.query;
    if (query.id) {
      this.get(query.id)
    }
  },
  methods: {
    get (id) {
      HTTPAUTH.get("/api/v1/salary-item/" + id).then(res => {
        this.si = res.data.data;
      })
    },
    save () {
      HTTPAUTH.post("/api/v1/salary-item", this.si).then(() => {
        this.$toasted.success("Berhasil disimpan").goAway(1000);
        this.reset();
        this.doBack()
      }).catch(eres => {
        this.$toasted.error(eres.response.data.message).goAway(3000);
        this.hasError = eres.response.data.error;
      })
    },
    update () {
      HTTPAUTH.put("/api/v1/salary-item/" + this.si.id, this.si).then(() => {
        this.$toasted.success("Berhasil disimpan").goAway(1000);
        this.reset();
        this.doBack()
      }).catch(eres => {
        this.$toasted.error(eres.response.data.message).goAway(3000);
        this.hasError = eres.response.data.error;
      })
    },
    doBack () {
      this.$router.push('/master/salary-item')
    },
    reset () {
      this.si = {};
      this.$router.push({ query: {} })
    },
  }
}
</script>

<style scoped>
</style>
